import { render } from "./FlipGrid.vue?vue&type=template&id=47c5db38"
import script from "./FlipGrid.vue?vue&type=script&lang=js"
export * from "./FlipGrid.vue?vue&type=script&lang=js"

import "./FlipGrid.vue?vue&type=style&index=0&id=47c5db38&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__